module.exports = __webpack_public_path__ + "img/please.14d1ba61.jpg";